import { render } from "./OrderMainInfo.vue?vue&type=template&id=ff20280e&scoped=true"
import script from "./OrderMainInfo.vue?vue&type=script&lang=js"
export * from "./OrderMainInfo.vue?vue&type=script&lang=js"

import "./OrderMainInfo.vue?vue&type=style&index=0&id=ff20280e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff20280e"]])

export default __exports__